/* eslint-disable react/forbid-prop-types, react/require-default-props */
import React from "react";
import PropTypes from "prop-types";
import gmbGemUrl from "../../../img/GMB_Logo.svg";
import "./gmbGem.css";

/**
 * Brand-gem primitive. Recolored via CSS mask (not multiple SVG files) so it
 * can follow either GMB's own app-chrome pink or a company's --gmb-primary
 * brand color, matching the recolor convention already used by CardBusy.
 */
const GmbGem = ({ size = 24, color = "#EE238A", className = "", style = {} }) => {
  const dimension = typeof size === "number" ? `${size}px` : size;
  return (
    <span
      className={`gmb-gem ${className}`}
      style={{
        width: dimension,
        height: dimension,
        backgroundColor: color,
        WebkitMaskImage: `url(${gmbGemUrl})`,
        maskImage: `url(${gmbGemUrl})`,
        ...style,
      }}
    />
  );
};

GmbGem.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default GmbGem;
